import {makeStyles} from "@material-ui/core";

const withStyles = makeStyles(theme => ({
    addBtn: {
        backgroundColor: theme.palette.secondary.dark
    }
}));

export default withStyles;